var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5185 7.51852C16.5185 10.014 14.4955 12.037 12 12.037C9.50445 12.037 7.48145 10.014 7.48145 7.51852C7.48145 5.02301 9.50445 3 12 3C14.4955 3 16.5185 5.02301 16.5185 7.51852Z",
    stroke: "#757893",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.96289 20.4286L3.17773 20.0757C7.20162 13.465 16.7982 13.465 20.8221 20.0757L21.037 20.4286",
    stroke: "#757893",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGray);
export default __webpack_public_path__ + "static/media/user-gray.4847dd53d38962b04b20dd2f74e69481.svg";
export { ForwardRef as ReactComponent };